import axiosClient from './axios.client';

export const chatCompletion = async ({
  username, prompt, model, conversationId, file,
}) => {
  try {
    const formData = new FormData();
    formData.append('prompt', prompt);
    formData.append('model', model);

    // Add conversationId if provided
    if (conversationId) {
      formData.append('conversationId', conversationId);
    }

    // Handle username for both JWT and Google OAuth users
    let effectiveUsername = username;

    // If no username, try to get from localStorage (Google OAuth or JWT)
    if (!effectiveUsername) {
      const storedUser = localStorage.getItem('user');
      const storedUsername = localStorage.getItem('username');

      if (storedUser) {
        try {
          const user = JSON.parse(storedUser);
          effectiveUsername = user.username || user.email || user.id;
        } catch (e) {
          console.error('Error parsing stored user:', e);
        }
      } else if (storedUsername) {
        effectiveUsername = storedUsername;
      }
    }

    if (effectiveUsername) {
      formData.append('username', effectiveUsername);
    }

    if (file) formData.append('file', file);

    const token = localStorage.getItem('tkn');
    const headers = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    console.log('🚀 Sending chat request for user:', effectiveUsername);

    const response = await axiosClient.post('chats', formData, {
      headers,
      withCredentials: true, // 🔥 Critical for session cookie support (OAuth)
      // Add timeout for mobile browsers
      timeout: 600000, // 10 minutes for Ollama models
    });

    return { response };
  } catch (err) {
    console.error('Chat API error:', err);
    return { err };
  }
};
